import { render, staticRenderFns } from "./Families.vue?vue&type=template&id=5cbd9e8f&scoped=true"
import script from "./Families.vue?vue&type=script&lang=js"
export * from "./Families.vue?vue&type=script&lang=js"
import style0 from "./Families.vue?vue&type=style&index=0&id=5cbd9e8f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbd9e8f",
  null
  
)

export default component.exports